import { apiCall, createUser } from "../utility/apiCall";
export const loadDashboard = async payload => {
  const dashboardResponse = await apiCall("api/dashboard", "GET");

  return dashboardResponse;
};

export const loadDashboardGraph = async payload => {
  const dashboardGraphResponse = await apiCall(
    "api/dashboard/dashboardGraphDetails",
    "POST",
    payload
  );

  return dashboardGraphResponse;
};



// WEBPACK FOOTER //
// ./src/services/dashboard.js